import { ServiceItemStyled } from './service-item.styled';

export interface ServiceItemProps {
  service: any;
  icon?: any;
}

const ServiceItem = (props: ServiceItemProps) => {
  return (
    <ServiceItemStyled.Container>
      {props.icon && (
        <ServiceItemStyled.ContainerIcon>
          {props.icon}
        </ServiceItemStyled.ContainerIcon>
      )}
      <ServiceItemStyled.ContainerContent>
        <ServiceItemStyled.Title>{props.service.name}</ServiceItemStyled.Title>
        <ServiceItemStyled.Description>
          {props.service.description && props.service.description}
        </ServiceItemStyled.Description>
      </ServiceItemStyled.ContainerContent>
    </ServiceItemStyled.Container>
  );
};

export default ServiceItem;
